import { assert } from "@/helpers/helpers";
import { mustLoginError } from "@/state/server";
import type { AppStatus } from "@/state/types";
import { createContext, useContext, type Context } from "react";

const _global = globalThis as any;
export const AppContext: Context<AppStatus | undefined> =
  _global.__AppContext ??
  (_global.__AppContext = createContext<AppStatus | undefined>(undefined));

export function useAppContext(mustBeLogged = false) {
  const res = useContext(AppContext);
  assert(res);
  if (mustBeLogged && !res.state.usuario.id) throw mustLoginError;
  return res;
}
